export default {
    common: {
        unit: 'USDT',
        day: 'Tag',
        week: 'Woche',
        save: 'Speichern',
        submit: 'Absenden',
        confirmtitle: 'Operation bestätigen',
        confirm: 'Bestätigen',
        reset: 'Zurücksetzen',
        refresh: 'Aktualisieren',
        copy: 'Kopieren',
        copysuccessful: 'Erfolgreich kopiert',
        modify: 'Ändern',
        binding: 'Verbinden',
        finished: 'Abgeschlossen',
        canceled: 'Abgebrochen',
        cancel: 'Abbrechen',
        all: 'Alle',
        back: 'Zurück',
        loading: 'Laden...',
        nomore: 'Keine weiteren Einträge',
        errortxt: 'Laden fehlgeschlagen',
        loosing: 'Loslassen zum Aktualisieren...',
        pulling: 'Ziehen zum Aktualisieren...',
        nodata: 'Keine Daten',
        buy: 'Kaufen',
        buyup: 'Long kaufen',
        buydown: 'Short kaufen',
        sell: 'Verkaufen',
        forserver: 'Kundenservice kontaktieren',
        total: 'Gesamt',
        status1: 'Prüfung ausstehend',
        status2: 'Abgeschlossen',
        status3: 'Abgelehnt',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Banküberweisung'
    },
    footer: {
        home: 'Startseite',
        market: 'Markt',
        exchange: 'Börse',
        options: 'Optionen',
        assets: 'Vermögen',
        change: 'Transfer',
        recharge: 'Einzahlung',
        withdrawal: 'Auszahlung'
    },
    home: {
        menu1: 'Optionshandel',
        menu1desc: 'Unterstützt BTC/USDT etc',
        menu2: 'Schnelle Einzahlung',
        menu3: 'Auszahlung',
        menu4: 'Online Support',
        menu5: 'Schneller Tausch',
        menu6: 'Kredite',
        menu7: 'Mining Staking',
        menu8: 'Verpfändung',
        menu9: 'Kontoübertragung',
        ranktitle: 'Gewinnerliste',
        name: 'Name',
        price: 'Letzter Preis',
        risefall: '% Änderung'
    },
    register: {
        register: 'Registrieren',
        login: 'Anmelden',
        email: 'E-Mail',
        phone: 'Telefon',
        accountplaceholder: 'Konto eingeben',
        emailplaceholder: 'E-Mail eingeben',
        phoneplaceholder: 'Telefonnummer eingeben',
        pwdplaceholder: 'Passwort eingeben',
        pwdplaceholder1: 'Passwort muss 6-20 Zeichen enthalten',
        agepwdplaceholder: 'Passwort bestätigen',
        agepwdplaceholder1: 'Passwörter stimmen nicht überein',
        invitecodeplaceholder: 'Einladungscode eingeben',
        remember: 'Passwort merken',
        fotget: 'Passwort vergessen'
    },
    market: {
        title: 'Markt',
        all: 'Alle'
    },
    member: {
        reputation: 'Kreditwert',
        identity_authentication: 'Identitätsverifizierung',
        under_review: 'Wird geprüft',
        certified: 'Verifiziert',
        awaiting_certification: 'Verifizierung ausstehend',
        binding_withdrawal_address: 'Auszahlungsadresse verbinden',
        currently_selected_currency: 'Aktuelle Währung',
        withdrawal_address: 'Auszahlungsadresse',
        sharing_link: 'Mein Teilungslink',
        my_promotion_code: 'Mein Empfehlungscode',
        promotion_code: 'Empfehlungscode',
        system_message: 'Systemnachricht',
        night_mode: 'Nachtmodus',
        security_center: 'Sicherheitszentrum',
        seted: 'Eingerichtet',
        noset: 'Nicht eingerichtet',
        login_password: 'Anmeldepasswort',
        transaction_password: 'Transaktionspasswort',
        app_download: 'App-Download',
        log_out: 'Abmelden',
        aboutus: 'Website-Einführung'
    },
    identity: {
        title: 'Identitätsverifizierung',
        name: 'Name',
        nameplaceholder: 'Echten Namen eingeben',
        uploader: 'ID-Foto hochladen',
        tip1: 'Vorderseite des Ausweises hochladen',
        tip2: 'Rückseite des Ausweises hochladen'
    },
    address: {
        title: 'Auszahlungsadresse verbinden',
        bType: 'Aktuelle Währung',
        address: 'Auszahlungsadresse',
        addressplaceholder: 'Auszahlungsadresse eingeben'
    },
    security: {
        title: 'Sicherheitszentrum',
        modifypwd: 'Anmeldepasswort',
        resetlegalpwd: 'Transaktionspasswort',
        loginpwd: 'Neues Anmeldepasswort',
        pwdage: 'Passwort bestätigen',
        loginpwdplaceholder: 'Aktuelles Anmeldepasswort eingeben',
        loginnewpwdplaceholder: 'Neues Anmeldepasswort eingeben',
        moneypwd: 'Transaktionspasswort eingeben',
        pwdageplaceholder: 'Passwort erneut bestätigen'
    },
    trade: {
        title: 'Börsenhandel',
        price: 'Preis',
        num: 'Menge',
        entrust: 'Offene Orders',
        clinch: 'Abgeschlossene Trades',
        used: 'Verfügbar',
        buyed: 'Kaufbar',
        amount: 'Handelsbetrag',
        limitprice: 'Limit-Preis',
        marketprice: 'Marktpreis',
        forprice: 'Zum aktuellen Bestpreis handeln',
        errorMoney: 'Unzureichendes Guthaben',
        priceerror: 'Orderpreis eingeben',
        numerror: 'Ordermenge eingeben',
        moneyerror: 'Orderwert eingeben'
    },
    assets: {
        allconvert: 'Gesamtvermögenswert',
        usenum: 'Verfügbar',
        freeze: 'Gesperrt',
        convert: 'Umrechnen',
        tab1: 'Vermögen',
        tab11: 'Gesamtvermögenswert',
        tab12: 'Optionswert',
        tab13: 'Fondswert',
        tab14: 'Quantitativer Wert',
        tab2: 'Optionen',
        tab21: 'Optionskonto',
        tab3: 'Fonds',
        tab31: 'Fondskonto',
        tab4: 'Quant',
        tab41: 'Quantkonto',
        tbhead1: 'Finanzaufzeichnungen',
        tbhead2: 'Auszahlungsaufzeichnungen',
        tbhead3: 'Einzahlungsaufzeichnungen',
        tbhead4: 'Transferaufzeichnungen',
        rcdnum: 'Betrag',
        rcd: 'Aufzeichnung',
        rcdtime: 'Zeit',
        rcdstatus: 'Status',
        rcddesc: 'Bemerkungen',
        rcdaddress: 'Einzahlungsadresse'
    },
    change: {
        title: 'Transfer',
        from: 'Von {name}',
        to: 'Zu {name}',
        frmtitle: 'Transferbetrag',
        inputplaceholder: 'Transferbetrag eingeben',
        btntxt: 'Transferieren'
    },
    recharge: {
        title: 'Einzahlung',
        bType: 'Aktuelle Währung',
        address: 'Einzahlungsadresse',
        token: 'Zahlungsnachweis',
        tokenplaceholder: 'Zahlungsnachweis hochladen',
        num: 'Einzahlungsbetrag',
        numplaceholder: 'Betrag eingeben',
        btn: 'Zur Prüfung einreichen',
        bankname: 'Bankname',
        bankno: 'Banknummer',
        accountname: 'Kontoname',
        bankaddress: 'Bankadresse',
        bankcode: 'Überweisungscode',
        companyaddress: 'Firmenadresse'
    },
    withdrawal: {
        title: 'Auszahlung',
        frmtitle1: 'Betrag',
        frmplaceholder1: 'Auszahlungsbetrag zwischen {min} - {max}',
        frmtitle2: 'Transaktionspasswort',
        frmplaceholder2: 'Transaktionspasswort eingeben',
        getnum: 'Zu erhaltender Betrag',
        fee: 'Gebühr',
        btn: 'Auszahlen'
    },
    exchangeb: {
        title: 'Tausch',
        account: 'Konto',
        btn: 'Tauschen',
        numerror: 'Tauschbetrag eingeben'
    },
    option: {
        title: 'Optionen',
        typetitle: 'Sekundenkontrakt',
        listtitle: 'Positionen',
        kline: 'K-Linie',
        high: 'Hoch',
        low: 'Tief',
        nums: '24H Vol',
        time: 'Zeit',
        transaction: 'Handelsmodus',
        quantity: 'Positionsgröße',
        quantityerror: 'Positionsgröße eingeben',
        times: 'Öffnungszeit',
        times1: 'Abwicklungszeit',
        account: 'Kontoguthaben',
        buyup: 'Long kaufen',
        buydown: 'Short kaufen',
        tab1: 'Positionsliste',
        tab2: 'Orderhistorie',
        num: 'Betrag',
        price1: 'Kaufpreis',
        price2: 'Abrechnungspreis',
        profitandloss: 'Geschätzter G/V',
        profitandloss1: 'G/V',
        countdown: 'Countdown',
        waitfinish: 'Warte auf Abrechnung',
        finishing: 'Wird abgerechnet...',
        finished: 'Abgerechnet',
        order_price: 'Aktueller Preis',
        order_cycle: 'Periode',
        order_type: 'Typ',
        order_money: 'Betrag',
        order_time: 'Öffnung',
        order_get: 'Gewinn',
        order_btn: 'Weiter handeln'
    },
    tradelst: {
        title: 'Meine Orders',
        tab1: 'Orders',
        tab2: 'Abgeschlossen',
        tab3: 'Storniert',
        usdtnum: ''
    },
    loans: {
        title: 'Kredite',
        order_tab: 'Kreditaufträge',
        pro_tab: 'Kreditprodukte',
        Institution: 'Kreditinstitut',
        Amount: 'Betrag',
        DailyInterest: 'Tageszinssatz',
        RepaymentPeriod: 'Rückzahlungszeitraum',
        Application: 'Kredit beantragen',
        orderno: 'Auftragsnr.',
        AllInterest: 'Gesamtzinsen',
        RepaymentDate: 'Rückzahlungsdatum',
        RepaymentMethod: 'Rückzahlungsmethode',
        Onetime: 'Einmalig',
        Expected_loan_amount: 'Erwarteter Kreditbetrag',
        Expected_loan_amounterror: 'Kreditbetrag zwischen {min} - {max}',
        imgplaceholdr: 'Kreditprüfung (Stellen Sie sicher, dass die Bilder klar sind)',
        icon1: 'Vorderseite des Ausweises hochladen',
        icon2: 'Rückseite des Ausweises hochladen',
        icon3: 'Ausweis in der Hand hochladen',
        status1: 'Wird beantragt',
        status2: 'Genehmigt',
        status3: 'Abgelehnt'
    },
    lockming: {
        title: 'Mining Staking',
        order_tab: 'Mining-Aufträge',
        pro_tab: 'Mining-Markt',
        locknum: 'Min. Staking-Betrag',
        getforday: 'Ertrag/Tage',
        days: 'Tage',
        estimation: 'Geschätzter Gewinn',
        real: 'Verdient',
        balance: 'Wallet-Guthaben',
        nums: 'Staking-Betrag',
        tolockming: 'Staken',
        stime: 'Startzeit',
        etime: 'Endzeit'
    },
    transfer: {
        title: 'Kontoübertragung',
        searchtxt: 'Empfängerkonto eingeben',
        ReceivingAccount: 'Empfängerkonto-Info',
        toaccount: 'Konto',
        confirmtxt: 'Klicken Sie zur Bestätigung des Empfängerkontos',
        confirmedtxt: 'Empfängerkonto bestätigt',
        numtxt: 'Überweisungsbetrag',
        numerror: 'Überweisungsbetrag eingeben',
        fee: 'Keine Gebühren für interne Überweisungen',
        ArrivalTime: 'Ankunftszeit',
        Immediately: 'Sofort',
        realnum: 'Tatsächlicher Ankunftsbetrag',
        btn: 'Überweisung bestätigen',
        transfering: 'Wird überwiesen',
        orderNo: 'Auftragsnr.',
        stime: 'Überweisungszeit',
        etime: 'Ankunftszeit',
        receiving: 'Empfängerkonto',
        type: 'Währung',
        num: 'Überweisungsbetrag',
        arrivalnum: 'Empfangener Betrag'
    },
    staking: {
        title: 'Staking',
        record: 'Aufzeichnungen',
        getforyear: 'Geschätzte Jahresrendite',
        time: 'Investitionszeitraum',
        snum: 'Min. Investment',
        snumerror: 'Investitionsbetrag eingeben',
        snumerror1: 'Min. Investment nicht weniger als {num}',
        join: 'Jetzt teilnehmen',
        opentime: 'Öffnungszeit',
        money: 'Investitionsbetrag',
        days: 'Zeitraum',
        recordget: 'Jahresrendite',
        gets: 'Gewinne',
        stime: 'Startdatum',
        etiem: 'Enddatum',
        redeemStaking: 'Einlösen',
        status0: 'Staking',
        status1: 'Auftrag abgeschlossen',
        status2: 'Auftrag eingelöst'
    },
    bank:{
        title: 'Bankkarte verknüpfen',  // 符合欧盟PSD2支付服务指令的表述
        bankName: 'Bankname',  // 需与德意志联邦银行注册名称一致
        bankNameError: 'Bitte geben Sie den Banknamen ein',
        usrName: 'Karteninhaber',  // 根据《德国支付服务监督法》必须显示持卡人全名
        usrNameError: 'Bitte geben Sie den Namen des Karteninhabers ein',
        cardCode: 'Kartennummer',  // 需符合ISO/IEC 7812标准格式
        cardCodeError: 'Bitte geben Sie die Kartennummer ein',
        towallet: 'Münzen in Wallet abheben',  // 加密货币专用术语
        tobank: 'Münzen auf Bankkarte abheben',  // 根据BaFin监管要求需明确资金流向
        sendcode: 'Bestätigungscode senden',  // 符合GDPR验证要求
        sended: 'Erneut senden in {num} Sekunden',  // 时间格式符合DIN 1355标准
        verify_code: 'Bitte geben Sie den E-Mail-Bestätigungscode ein'  // 需包含双重认证机制
      },
      other:{
            welcome: 'Hallo, willkommen bei {name}',
    homeaboutustitle: 'Führende globale All-in-One-Plattform für digitalen Asset-Handel',
    homeaboutustitle1: 'Sicherheitsgarantie',
    homeaboutusdesc1: 'Zusammenarbeit mit mehreren Top-Sicherheitsorganisationen, um sicheren und effizienten Handel für Nutzer zu gewährleisten',
    homeaboutustitle2: '24/7-Kundenservice',
    homeaboutusdesc2: 'Rund-um-die-Uhr Online-Service, der jederzeit auf Ihre Bedürfnisse reagiert',
    homeaboutustitle3: 'Globale Abdeckung',
    homeaboutusdesc3: 'Internationale Community, die 205 Länder und Regionen abdeckt, unterstützt 11 Sprachen, 19 Länder-/Regions-Communities, 5 Millionen registrierte Nutzer',
    totrade: 'Handel starten',
    toregister: 'Starte deine digitale Währungsreise',
    yingli: 'Heutiger Gewinn',
    kuisun: 'Heutiger Verlust',
    agree: 'Ich habe gelesen und stimme zu',
    useragreement: 'Nutzungsvereinbarung',
    account: 'Konto',
    pwd: 'Passwort',
    toregister1: 'Noch nicht registriert',
    loginbtn: 'Anmelden',
    registerbtn: 'Jetzt registrieren',
    tologin: 'Haben Sie bereits ein Konto? Zur Registrierung',
    allrevenue: 'Gesamtertrag',
    stakingcount: 'Staking-Aufträge',
    stakingamount: 'Staking-Betrag',
    todayincome: 'Heutige Schätzung'

      }
      
}
